import { render, staticRenderFns } from "./requisiteModalUnarchive.vue?vue&type=template&id=083cf59a&scoped=true"
import script from "./requisiteModalUnarchive.vue?vue&type=script&lang=js"
export * from "./requisiteModalUnarchive.vue?vue&type=script&lang=js"
import style0 from "./requisiteModalUnarchive.vue?vue&type=style&index=0&id=083cf59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cf59a",
  null
  
)

export default component.exports